export const EmptyStateAddDashboardIllustration = () => {
  return (
    <svg viewBox="0 0 176 175">
      <path
        fill="#D9E5FF"
        fillRule="evenodd"
        d="M18.678 39.038h117.935c2.663 0 6.087 1.902 6.087 6.087v50.287a31.666 31.666 0 0 0-7.228-.83c-17.439 0-31.576 14.136-31.576 31.575 0 2.487.287 4.907.831 7.228H18.678c-1.521 0-6.847-.38-6.847-6.087V45.886c0-5.327 3.424-6.848 6.847-6.848Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M126.824 50.093a3.693 3.693 0 0 1 3.695-3.692 3.693 3.693 0 1 1 0 7.384 3.67 3.67 0 0 1-1.492-.32l-9.612 8.25a.76.76 0 0 0 .009.082c.005.037.01.072.01.11a3.693 3.693 0 0 1-7.386.042l-6.901-3.457a3.674 3.674 0 0 1-2.71 1.2c-.384 0-.746-.076-1.094-.184l-7.31 8.395c.174.428.275.896.275 1.387a3.694 3.694 0 0 1-3.696 3.691 3.694 3.694 0 0 1-3.695-3.691 3.694 3.694 0 0 1 3.695-3.692c.457 0 .887.094 1.29.245l7.194-8.288A3.656 3.656 0 0 1 98.742 56a3.694 3.694 0 0 1 3.695-3.692 3.683 3.683 0 0 1 3.669 3.43l7.055 3.53a3.678 3.678 0 0 1 2.578-1.053c.871 0 1.659.313 2.291.816l9.007-7.75a3.661 3.661 0 0 1-.213-1.188Zm-72.802 8.793c0-.634.514-1.149 1.148-1.149 15.702.164 28.396 12.857 28.559 28.558a1.15 1.15 0 0 1-1.148 1.15c-.036 0-.07-.01-.102-.019a.544.544 0 0 0-.066-.015v.033H55.17a1.15 1.15 0 0 1-1.148-1.149V59.053h.034c-.004-.022-.01-.044-.016-.066a.37.37 0 0 1-.018-.1Zm22.67 33.922a1.14 1.14 0 0 0-1.134-1.144h-24.75c-.302 0-.59-.12-.803-.335a1.147 1.147 0 0 1-.333-.808V65.692h-.033a.559.559 0 0 1 .015-.066.369.369 0 0 0 .018-.1 1.14 1.14 0 0 0-1.135-1.144c-.015 0-.028.004-.041.008-.012.003-.023.007-.036.008v-.008a4.73 4.73 0 0 1-.14-.004c-.054-.002-.108-.004-.162-.004-15.759 0-28.535 12.863-28.535 28.73s12.776 28.73 28.535 28.73 28.535-12.863 28.535-28.73c0-.057-.002-.113-.004-.17a8.839 8.839 0 0 1-.002-.104c0-.011.006-.02.006-.03Zm56.592-19.9h-6.167c-.818 0-1.602.285-2.18.792-.578.507-.903 1.194-.903 1.91V96.81a32.197 32.197 0 0 1 12.333-2.226V75.61c0-.716-.325-1.403-.903-1.91-.578-.507-1.363-.791-2.18-.791Zm-15.417 18.908v8.238c-5.715 3.853-10.1 9.49-12.334 16.101V91.816c0-.716.325-1.403.904-1.91.578-.506 1.362-.79 2.18-.79h6.167c.817 0 1.602.284 2.18.79.578.507.903 1.194.903 1.91Zm-21.584 13.506h-6.166c-.818 0-1.602.284-2.18.791-.579.506-.904 1.193-.904 1.91v13.483h12.334v-13.483c0-.717-.325-1.404-.903-1.91-.579-.507-1.363-.791-2.18-.791Z"
        clipRule="evenodd"
      />
      <path
        fill="#9DB9F2"
        d="M163.169 126.071c0 15.128-12.263 27.392-27.391 27.392-15.128 0-27.391-12.264-27.391-27.392 0-15.127 12.263-27.39 27.391-27.39 15.128 0 27.391 12.263 27.391 27.39Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M137.987 115.026a2.209 2.209 0 1 0-4.418 0v8.836h-8.836a2.209 2.209 0 1 0 0 4.418h8.836v8.836a2.209 2.209 0 1 0 4.418 0v-8.836h8.836a2.209 2.209 0 1 0 0-4.418h-8.836v-8.836Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9E5FF"
        d="M40.645 27.428a5.89 5.89 0 1 1-11.781 0 5.89 5.89 0 0 1 11.781 0Z"
      />
      <path
        fill="#9DB9F2"
        d="M98.775 143.911a4.11 4.11 0 1 1 6.643-4.844 4.111 4.111 0 0 1-6.643 4.844Z"
      />
      <path
        fill="#D9E5FF"
        d="M51.69 33.319a2.945 2.945 0 1 1-5.89 0 2.945 2.945 0 0 1 5.89 0Z"
      />
      <path
        fill="#9DB9F2"
        d="M106.927 149.202a2.056 2.056 0 1 1 3.323-2.422 2.056 2.056 0 0 1-3.323 2.422Z"
      />
    </svg>
  );
};

export const EmptyStateNoResultIllustration = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 176 175" fill="none">
      <path
        fill="#9DB9F2"
        fillRule="evenodd"
        d="M29.06 42.206c-3.565.97-5.676 4.625-4.713 8.164l22.486 82.683c.963 3.539 4.634 5.621 8.2 4.652l24.995-6.798a36.206 36.206 0 0 1-4.953-18.336c0-20.089 16.285-36.374 36.374-36.374.358 0 .715.005 1.07.015l-8.435-31.018-27.635-15.876L29.06 42.206Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9E5FF"
        fillRule="evenodd"
        d="M39.71 22.212a6.691 6.691 0 0 0-6.69 6.691v95.588a6.691 6.691 0 0 0 6.69 6.691h45.464c-5.3-5.716-8.546-13.406-8.546-21.863 0-17.649 14.137-31.956 31.576-31.956 2.756 0 5.429.357 7.976 1.028V47.065L92.283 22.212H39.71Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M40.665 38.46a2.868 2.868 0 0 1 2.868-2.867H74.12a2.868 2.868 0 1 1 0 5.735H43.533a2.868 2.868 0 0 1-2.868-2.867Zm0 76.472a2.868 2.868 0 0 1 2.868-2.868h33.18c.142 1.966.46 3.882.938 5.735H43.533a2.868 2.868 0 0 1-2.868-2.867Zm52.342-33.364a2.875 2.875 0 0 0-.725-.093h-48.75a2.868 2.868 0 0 0 0 5.736h42.196a32.467 32.467 0 0 1 7.279-5.643Zm-13.69 15.201H43.533a2.868 2.868 0 0 0 0 5.736H77.43a32.094 32.094 0 0 1 1.886-5.736ZM43.533 50.887a2.868 2.868 0 0 0 0 5.735h37.279a2.868 2.868 0 1 0 0-5.735h-37.28ZM40.665 69.05a2.868 2.868 0 0 1 2.868-2.868h62.132a2.868 2.868 0 0 1 0 5.736H43.533a2.868 2.868 0 0 1-2.868-2.868Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9E5FF"
        d="M132.932 108.938c0 13.657-11.071 24.728-24.728 24.728-13.657 0-24.728-11.071-24.728-24.728 0-13.657 11.071-24.728 24.728-24.728 13.657 0 24.728 11.071 24.728 24.728Z"
      />
      <path
        fill="#9DB9F2"
        fillRule="evenodd"
        d="M108.585 131.054c12.424 0 22.496-10.072 22.496-22.496 0-12.425-10.072-22.497-22.496-22.497-12.425 0-22.497 10.072-22.497 22.497 0 12.424 10.072 22.496 22.497 22.496Zm0 4.895c15.127 0 27.391-12.263 27.391-27.391 0-15.128-12.264-27.392-27.391-27.392-15.128 0-27.392 12.264-27.392 27.392s12.264 27.391 27.392 27.391Z"
        clipRule="evenodd"
      />
      <path
        fill="#9DB9F2"
        fillRule="evenodd"
        d="m147.783 148.68-21.397-20.326 3.95-4.158 21.397 20.326a2.869 2.869 0 0 1-3.95 4.158Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M119.037 100.35c-3.464-4.175-8.178-5.27-13.24-4.185a2.868 2.868 0 1 1-1.201-5.608c6.705-1.436 13.76-.01 18.855 6.132a2.868 2.868 0 1 1-4.414 3.661Z"
        clipRule="evenodd"
      />
      <path
        fill="#9DB9F2"
        d="m92.282 22.212 23.897 24.853h-16.25a7.647 7.647 0 0 1-7.647-7.647V22.212ZM122.773 77.409a4.895 4.895 0 1 1 6.923-6.924 4.895 4.895 0 0 1-6.923 6.924Z"
      />
      <path
        fill="#D9E5FF"
        d="M90.106 142.403a4.895 4.895 0 1 1-6.923 6.923 4.895 4.895 0 0 1 6.922-6.923Z"
      />
      <path
        fill="#9DB9F2"
        d="M133.341 82.131a2.448 2.448 0 1 1 3.461-3.461 2.448 2.448 0 0 1-3.461 3.461Z"
      />
      <path
        fill="#D9E5FF"
        d="M79.538 137.68a2.448 2.448 0 1 1-3.463 3.462 2.448 2.448 0 0 1 3.463-3.462Z"
      />
    </svg>
  );
};

export const EmptyStateToAddIllustration = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 175 175" fill="none">
      <path
        fill="#fff"
        d="m32.734 67.452 24.31-35.48h60.33l22.788 29.363 4.476 10.603-4.476 6.933-30.113-1.223L95.4 89.067H73.426l-10.173-11.42-22.788 1.224-7.731-11.419Z"
      />
      <circle
        cx="128.223"
        cy="25.178"
        r="5.423"
        fill="#D9E5FF"
        transform="rotate(45 128.223 25.178)"
      />
      <circle
        cx="133.972"
        cy="36.132"
        r="2.276"
        fill="#D9E5FF"
        transform="rotate(45 133.972 36.132)"
      />
      <circle
        cx="43.726"
        cy="135.368"
        r="4.552"
        fill="#9DB9F2"
        transform="rotate(45 43.726 135.368)"
      />
      <circle
        cx="49.726"
        cy="127.152"
        r="2.276"
        fill="#9DB9F2"
        transform="rotate(45 49.726 127.152)"
      />
      <path
        fill="#D9E5FF"
        fillRule="evenodd"
        d="M148.719 101.051c0 10.684-5.446 16.079-16.287 16.079h-14.406c-4.069-12.744-16.007-21.974-30.101-21.974-14.093 0-26.031 9.229-30.1 21.972H42.652c-10.788 0-16.287-5.342-16.287-16.079V72.42c0-4.67.78-6.844 2.959-9.852l17.942-24.223c5.654-7.727 8.768-9.75 17.947-9.75h44.655c9.184 0 12.295 2.023 17.947 9.75l17.947 24.223c2.177 3.008 2.956 5.185 2.956 9.854v28.629Zm-73.96-27.075c0 6.38 4.979 13.123 12.757 13.123 7.832 0 12.813-6.743 12.813-13.123v-.155c0-2.335 1.401-4.512 4.253-4.512h33.037c1.711 0 2.074-1.454 1.244-2.594l-19.138-26.347c-2.438-3.32-5.499-4.514-9.283-4.514H64.643c-3.786 0-6.846 1.192-9.283 4.512l-19.19 26.35c-.83 1.139-.467 2.59 1.245 2.59h33.09c2.853 0 4.254 2.18 4.254 4.515v.155Z"
        clipRule="evenodd"
      />
      <path
        fill="#9DB9F2"
        d="M115.227 127.136c0 15.135-12.269 27.405-27.405 27.405-15.135 0-27.405-12.27-27.405-27.405 0-15.136 12.27-27.405 27.405-27.405 15.136 0 27.405 12.269 27.405 27.405Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M90.032 116.085a2.21 2.21 0 1 0-4.42 0v8.84h-8.84a2.21 2.21 0 1 0 0 4.42h8.84v8.84a2.21 2.21 0 1 0 4.42 0v-8.84h8.84a2.21 2.21 0 1 0 0-4.42h-8.84v-8.84Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const EmptyStateSuccessIllustration = () => {
  return (
    <svg viewBox="0 0 176 175" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="29.8042"
        y="32.7173"
        width="108.043"
        height="32.7174"
        rx="6.08696"
        fill="#D9E5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8695 69.9995C13.5078 69.9995 10.7826 72.7247 10.7826 76.0865V96.6299C10.7826 99.9917 13.5078 102.717 16.8696 102.717H107.594C109.949 96.977 113.87 92.0453 118.826 88.4537V76.0865C118.826 72.7247 116.101 69.9995 112.739 69.9995H16.8695Z"
        fill="#D9E5FF"
      />
      <circle cx="25.9999" cy="85.9781" r="9.13043" fill="#9DB9F2" />
      <rect
        x="40.4564"
        y="79.8911"
        width="71.5217"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <rect
        x="40.4564"
        y="87.5"
        width="44.1304"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <path
        d="M132.635 83.8488C130.181 84.9831 127.272 83.9129 126.138 81.4586C125.003 79.0043 126.074 76.0952 128.528 74.9609C130.982 73.8267 133.891 74.8969 135.026 77.3512C136.16 79.8055 135.09 82.7146 132.635 83.8488Z"
        fill="#9DB9F2"
      />
      <path
        d="M20.2344 65.6106C17.5355 65.4483 15.4791 63.1289 15.6414 60.4301C15.8036 57.7312 18.123 55.6749 20.8219 55.8371C23.5208 55.9993 25.5771 58.3187 25.4149 61.0176C25.2526 63.7165 22.9332 65.7728 20.2344 65.6106Z"
        fill="#D9E5FF"
      />
      <path
        d="M140.68 75.693C139.453 76.2601 137.998 75.725 137.431 74.4979C136.864 73.2707 137.399 71.8161 138.626 71.249C139.853 70.6819 141.308 71.217 141.875 72.4441C142.442 73.6713 141.907 75.1259 140.68 75.693Z"
        fill="#9DB9F2"
      />
      <path
        d="M13.2259 53.7291C11.8764 53.648 10.8483 52.4883 10.9294 51.1389C11.0105 49.7894 12.1702 48.7613 13.5196 48.8424C14.8691 48.9235 15.8973 50.0832 15.8161 51.4326C15.735 52.7821 14.5753 53.8102 13.2259 53.7291Z"
        fill="#D9E5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.101 107.282H35.8913C32.5295 107.282 29.8043 110.007 29.8043 113.369V133.913C29.8043 137.274 32.5295 140 35.8913 140H116.228C109.419 133.937 105.13 125.105 105.13 115.271C105.13 112.517 105.467 109.841 106.101 107.282Z"
        fill="#D9E5FF"
      />
      <circle cx="137.087" cy="114.891" r="27.3913" fill="#9DB9F2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.583 105.14C153.418 106.084 153.33 107.527 152.386 108.362L133.17 125.369C132.245 126.188 130.836 126.122 129.992 125.22L123.032 117.79C122.17 116.87 122.217 115.425 123.138 114.563C124.058 113.701 125.502 113.749 126.364 114.669L131.807 120.48L149.361 104.944C150.305 104.108 151.747 104.196 152.583 105.14Z"
        fill="white"
      />
      <circle cx="45.0217" cy="48.6954" r="9.13043" fill="#9DB9F2" />
      <rect
        x="59.4781"
        y="42.6084"
        width="71.5217"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <rect
        x="59.4781"
        y="50.2173"
        width="44.1304"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <circle cx="45.0217" cy="123.261" r="9.13043" fill="#9DB9F2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.184 117.174H61.7608C60.5001 117.174 59.4781 118.196 59.4781 119.456C59.4781 120.717 60.5001 121.739 61.7608 121.739H105.762C105.467 120.251 105.272 118.727 105.184 117.174ZM59.4781 127.065C59.4781 125.804 60.5001 124.783 61.7608 124.783H101.326C102.587 124.783 103.609 125.804 103.609 127.065C103.609 128.326 102.587 129.348 101.326 129.348H61.7608C60.5001 129.348 59.4781 128.326 59.4781 127.065Z"
        fill="white"
      />
    </svg>
  );
};

export const EmptyStateNotFoundIllustration = () => {
  return (
    <svg viewBox="0 0 175 175" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1521 45.2715C24.7904 45.2715 22.0652 47.9967 22.0652 51.3585V121.358C22.0652 124.72 24.7904 127.445 28.1521 127.445H63.8386L84.0779 93.1059C86.9887 88.1673 94.0982 88.1673 97.009 93.1059L117.248 127.445H146.848C150.21 127.445 152.935 124.72 152.935 121.358V51.3584C152.935 47.9967 150.21 45.2715 146.848 45.2715H28.1521Z"
        fill="#D9E5FF"
      />
      <path
        d="M88.2466 95.2829C89.286 93.5287 91.8248 93.5287 92.8642 95.2829L122.145 144.698C123.205 146.487 121.916 148.75 119.836 148.75H61.2747C59.1953 148.75 57.9059 146.487 58.9659 144.698L88.2466 95.2829Z"
        fill="#9DB9F2"
      />
      <path
        d="M90.1631 133.806C89.5887 133.806 89.184 133.611 88.949 133.222C88.7402 132.832 88.6227 132.373 88.5966 131.845L87.8525 112.398C87.8264 111.48 87.9569 110.715 88.2441 110.103C88.5574 109.491 89.1971 109.185 90.1631 109.185C90.9985 109.185 91.586 109.449 91.9254 109.977C92.2648 110.478 92.4345 111.146 92.4345 111.981V112.398L91.6904 131.845C91.6643 132.373 91.5468 132.832 91.3379 133.222C91.1291 133.611 90.7375 133.806 90.1631 133.806ZM90.163 142.663C88.3877 142.663 87.5 141.703 87.5 139.783C87.5 138.977 87.7611 138.309 88.2832 137.78C88.8315 137.252 89.4712 136.987 90.2022 136.987C90.9071 136.987 91.5207 137.279 92.0428 137.864C92.565 138.42 92.8261 139.074 92.8261 139.825C92.8261 141.717 91.9384 142.663 90.163 142.663Z"
        fill="white"
      />
      <path
        d="M22.0652 51.3589C22.0652 47.9972 24.7904 45.272 28.1521 45.272H146.848C150.21 45.272 152.935 47.9972 152.935 51.3589V58.9676H22.0652V51.3589Z"
        fill="#9DB9F2"
      />
      <rect
        x="33.4783"
        y="77.228"
        width="106.522"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <rect
        x="33.4783"
        y="87.8804"
        width="33.4783"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <rect
        x="33.4783"
        y="67.3369"
        width="33.4783"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <path
        d="M141.704 39.8772C139.249 41.0114 136.34 39.9413 135.206 37.4869C134.072 35.0326 135.142 32.1235 137.596 30.9893C140.051 29.855 142.96 30.9252 144.094 33.3795C145.228 35.8338 144.158 38.7429 141.704 39.8772Z"
        fill="#9DB9F2"
      />
      <path
        d="M43.2751 131.732C45.6299 130.403 48.6159 131.235 49.9445 133.59C51.2731 135.945 50.4412 138.931 48.0865 140.259C45.7317 141.588 42.7457 140.756 41.4171 138.401C40.0885 136.047 40.9203 133.061 43.2751 131.732Z"
        fill="#D9E5FF"
      />
      <path
        d="M149.748 31.7208C148.521 32.2879 147.067 31.7529 146.499 30.5257C145.932 29.2985 146.467 27.844 147.695 27.2769C148.922 26.7097 150.376 27.2448 150.943 28.472C151.51 29.6991 150.975 31.1537 149.748 31.7208Z"
        fill="#9DB9F2"
      />
      <path
        d="M35.9149 140.511C37.0923 139.846 38.5853 140.262 39.2496 141.44C39.9139 142.617 39.498 144.11 38.3206 144.774C37.1432 145.439 35.6502 145.023 34.9859 143.845C34.3216 142.668 34.7375 141.175 35.9149 140.511Z"
        fill="#D9E5FF"
      />
    </svg>
  );
};

export const EmptyStateNoDashboardIllustration = () => (
  <svg viewBox="0 0 175 175" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="39" width="131" height="94" rx="6.5" fill="#D9E5FF" />
    <path
      d="M48.8799 64.1487C49.5068 64.1487 50.0155 64.6602 50.0156 65.2922C50.0156 65.3509 49.991 65.4023 49.9824 65.4592H50.0156V90.2874C50.0156 90.5904 50.1349 90.8815 50.3477 91.0959C50.5604 91.3104 50.8493 91.4307 51.1504 91.4309H75.9014C76.5281 91.431 77.0361 91.9434 77.0361 92.5745C77.0361 92.5848 77.0303 92.5935 77.0303 92.6047C77.032 92.697 77.0361 92.7877 77.0361 92.8792C77.036 108.746 64.2597 121.609 48.501 121.609C32.7424 121.608 19.9669 108.746 19.9668 92.8792C19.9668 77.0125 32.7424 64.1489 48.501 64.1487C48.602 64.1487 48.7026 64.1556 48.8037 64.1565V64.1643C48.8302 64.1626 48.8525 64.1487 48.8799 64.1487ZM96.627 105.089C97.4446 105.089 98.2295 105.374 98.8076 105.88C99.3854 106.387 99.71 107.074 99.71 107.79V121.274H87.377V107.79C87.377 107.074 87.702 106.387 88.2803 105.88C88.8584 105.374 89.6424 105.089 90.46 105.089H96.627ZM115.127 88.8821C115.945 88.8822 116.729 89.1667 117.308 89.6731C117.886 90.1796 118.211 90.8671 118.211 91.5833V121.274H105.877V91.5833C105.877 90.867 106.202 90.1796 106.78 89.6731C107.358 89.1667 108.143 88.8821 108.961 88.8821H115.127ZM133.627 72.676C134.445 72.6761 135.229 72.9606 135.808 73.467C136.386 73.9736 136.711 74.661 136.711 75.3772V121.274H124.377V75.3772C124.377 74.6608 124.702 73.9736 125.28 73.467C125.859 72.9605 126.643 72.676 127.461 72.676H133.627ZM55.5127 57.5042C71.215 57.6679 83.9091 70.3604 84.0723 86.0618C84.0723 86.6961 83.5573 87.2112 82.9238 87.2112C82.8641 87.2112 82.813 87.1857 82.7559 87.177V87.2112H55.5127C54.8794 87.2109 54.3652 86.6959 54.3652 86.0618V58.8206H54.3984C54.3898 58.7634 54.3652 58.7115 54.3652 58.6526C54.3655 58.0186 54.8796 57.5044 55.5127 57.5042ZM130.862 46.1682C132.903 46.1682 134.557 47.8212 134.558 49.8596C134.558 51.8989 132.904 53.552 130.862 53.552C130.33 53.552 129.827 53.4339 129.37 53.2317L119.758 61.4817C119.762 61.5465 119.777 61.6076 119.777 61.6731C119.777 63.7116 118.123 65.3645 116.082 65.3645C114.056 65.3644 112.415 63.7336 112.391 61.7151L105.49 58.2581C104.815 58.9912 103.855 59.4582 102.78 59.4583C102.397 59.4583 102.034 59.3834 101.687 59.2756L94.376 67.6702C94.5504 68.0984 94.6504 68.5659 94.6504 69.0569C94.6503 71.0952 92.9963 72.7481 90.9561 72.7483C88.9157 72.7483 87.2609 71.0953 87.2607 69.0569C87.2607 67.0183 88.9156 65.3645 90.9561 65.3645C91.4119 65.3645 91.8427 65.459 92.2461 65.6096L99.4395 57.3225C99.2178 56.8486 99.085 56.3249 99.085 55.7668C99.085 53.7283 100.74 52.0745 102.78 52.0745C104.731 52.0746 106.312 53.5908 106.449 55.5051L113.505 59.0344C114.17 58.3848 115.078 57.9818 116.082 57.9817C116.952 57.9817 117.741 58.2944 118.373 58.7971L127.38 51.0491C127.252 50.674 127.168 50.2783 127.168 49.8596C127.168 47.8213 128.821 46.1684 130.862 46.1682Z"
      fill="white"
    />
    <path
      d="M40.9882 27.195C40.9882 30.4483 38.3509 33.0856 35.0976 33.0856C31.8443 33.0856 29.207 30.4483 29.207 27.195C29.207 23.9418 31.8443 21.3044 35.0976 21.3044C38.3509 21.3044 40.9882 23.9418 40.9882 27.195Z"
      fill="#D9E5FF"
    />
    <path
      d="M113.045 144.836C113.045 141.582 115.682 138.945 118.936 138.945C122.189 138.945 124.826 141.582 124.826 144.836C124.826 148.089 122.189 150.726 118.936 150.726C115.682 150.726 113.045 148.089 113.045 144.836Z"
      fill="#9DB9F2"
    />
    <path
      d="M52.0332 33.0854C52.0332 34.7121 50.7145 36.0307 49.0879 36.0307C47.4612 36.0307 46.1426 34.7121 46.1426 33.0854C46.1426 31.4588 47.4612 30.1401 49.0879 30.1401C50.7145 30.1401 52.0332 31.4588 52.0332 33.0854Z"
      fill="#D9E5FF"
    />
    <path
      d="M102 138.945C102 137.319 103.319 136 104.945 136C106.572 136 107.891 137.319 107.891 138.945C107.891 140.572 106.572 141.891 104.945 141.891C103.319 141.891 102 140.572 102 138.945Z"
      fill="#9DB9F2"
    />
  </svg>
);

export const EmptyStateSecurityIllustration = () => (
  <svg viewBox="0 0 175 175" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(48.78, 39)">
      <circle
        cx="90.9346"
        cy="7.66961"
        r="5.42323"
        transform="rotate(45 90.9346 7.66961)"
        fill="#D9E5FF"
      />
      <circle
        cx="96.6836"
        cy="18.6229"
        r="2.27587"
        transform="rotate(45 96.6836 18.6229)"
        fill="#D9E5FF"
      />
      <circle
        cx="6.4375"
        cy="117.859"
        r="4.55173"
        transform="rotate(45 6.4375 117.859)"
        fill="#9DB9F2"
      />
      <circle
        cx="12.4375"
        cy="109.644"
        r="2.27587"
        transform="rotate(45 12.4375 109.644)"
        fill="#9DB9F2"
      />
      <path
        d="M38.7202 97C27.5074 94.1708 18.2509 87.7244 10.9505 77.6606C3.65018 67.5969 0 56.4217 0 44.135V14.55L38.7202 0L77.4403 14.55V44.135C77.4403 44.9433 77.4202 45.7517 77.3798 46.56C77.3395 47.3683 77.279 48.1767 77.1983 48.985C76.4723 48.8233 75.7262 48.7021 74.9598 48.6213C74.1935 48.5404 73.407 48.5 72.6003 48.5C71.713 48.5 70.866 48.5404 70.0593 48.6213C69.2526 48.7021 68.4056 48.8233 67.5183 48.985C67.5989 48.1767 67.6594 47.3885 67.6998 46.6206C67.7401 45.8527 67.7603 45.0242 67.7603 44.135V21.2188L38.7202 10.3062L9.68004 21.2188V44.135C9.68004 53.9158 12.4227 62.8075 17.9081 70.81C23.3934 78.8125 30.3308 84.1475 38.7202 86.815C40.4142 86.2492 42.0678 85.5621 43.6812 84.7538C45.2945 83.9454 46.8675 83.0158 48.4002 81.965V93.3625C46.8675 94.1708 45.2945 94.8781 43.6812 95.4844C42.0678 96.0906 40.4142 96.5958 38.7202 97ZM62.1943 97C61.0649 97 60.0969 96.5958 59.2902 95.7875C58.4836 94.9792 58.0802 94.0092 58.0802 92.8775V76.8725C58.0802 75.7408 58.4836 74.7708 59.2902 73.9625C60.0969 73.1542 61.0649 72.75 62.1943 72.75H62.9203V67.9C62.9203 65.2325 63.8681 62.949 65.7638 61.0494C67.6595 59.1498 69.9383 58.2 72.6003 58.2C75.2623 58.2 77.5412 59.1498 79.4368 61.0494C81.3325 62.949 82.2803 65.2325 82.2803 67.9V72.75H83.0063C84.1357 72.75 85.1037 73.1542 85.9104 73.9625C86.717 74.7708 87.1204 75.7408 87.1204 76.8725V92.8775C87.1204 94.0092 86.717 94.9792 85.9104 95.7875C85.1037 96.5958 84.1357 97 83.0063 97H62.1943ZM67.7603 72.75H77.4403V67.9C77.4403 66.5258 76.9765 65.374 76.0488 64.4444C75.1212 63.5148 73.9716 63.05 72.6003 63.05C71.229 63.05 70.0795 63.5148 69.1518 64.4444C68.2241 65.374 67.7603 66.5258 67.7603 67.9V72.75Z"
        fill="#D9E5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.1943 97C61.0649 97 60.0969 96.5958 59.2902 95.7875C58.4836 94.9792 58.0802 94.0092 58.0802 92.8775V76.8725C58.0802 75.7408 58.4836 74.7708 59.2902 73.9625C60.0969 73.1542 61.0649 72.75 62.1943 72.75H62.9203V67.9C62.9203 65.2325 63.8681 62.949 65.7638 61.0494C67.6595 59.1498 69.9383 58.2 72.6003 58.2C75.2623 58.2 77.5412 59.1498 79.4368 61.0494C81.3325 62.949 82.2803 65.2325 82.2803 67.9V72.75H83.0063C84.1357 72.75 85.1037 73.1542 85.9104 73.9625C86.717 74.7708 87.1204 75.7408 87.1204 76.8725V92.8775C87.1204 94.0092 86.717 94.9792 85.9104 95.7875C85.1037 96.5958 84.1357 97 83.0063 97H62.1943ZM77.4403 72.75H67.7603V67.9C67.7603 66.5258 68.2241 65.374 69.1518 64.4444C70.0795 63.5148 71.229 63.05 72.6003 63.05C73.9716 63.05 75.1212 63.5148 76.0488 64.4444C76.9765 65.374 77.4403 66.5258 77.4403 67.9V72.75Z"
        fill="#9DB9F2"
      />
    </g>
  </svg>
);
